/**
 * @generated SignedSource<<c6067e54494ab082450f09002f70925c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RatecardProjectProviderRatecardProjectProposalsQuery$variables = {
  id: string;
};
export type RatecardProjectProviderRatecardProjectProposalsQuery$data = {
  readonly ratecardProjectProposals: {
    readonly editMode: boolean | null;
    readonly onHold: boolean | null;
    readonly projectId: string | null;
    readonly projectName: string | null;
    readonly proposals: ReadonlyArray<{
      readonly archived: boolean | null;
      readonly projectId: string | null;
      readonly proposalId: string | null;
      readonly state: string | null;
    } | null> | null;
    readonly state: string | null;
  } | null;
};
export type RatecardProjectProviderRatecardProjectProposalsQuery = {
  response: RatecardProjectProviderRatecardProjectProposalsQuery$data;
  variables: RatecardProjectProviderRatecardProjectProposalsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projectId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "RatecardProjectProposalsNode",
    "kind": "LinkedField",
    "name": "ratecardProjectProposals",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "editMode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "onHold",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "projectName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RatecardProjectProposalEntryNode",
        "kind": "LinkedField",
        "name": "proposals",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "proposalId",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RatecardProjectProviderRatecardProjectProposalsQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RatecardProjectProviderRatecardProjectProposalsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f9c4fe2a96d8e6ca9efff68656116075",
    "id": null,
    "metadata": {},
    "name": "RatecardProjectProviderRatecardProjectProposalsQuery",
    "operationKind": "query",
    "text": "query RatecardProjectProviderRatecardProjectProposalsQuery(\n  $id: ID!\n) {\n  ratecardProjectProposals(id: $id) {\n    projectId\n    state\n    editMode\n    onHold\n    projectName\n    proposals {\n      projectId\n      proposalId\n      state\n      archived\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "87dac28b876ac95fadfa08575ae697af";

export default node;
